import React from 'react';
import cx from 'classnames';

import { ReactComponent as QuipuswapLogo404 } from 'app/components/svg/QuipuswapLogo404.svg';

import s from './NotFound.module.sass';

const NotFound: React.FC = () => (
  <div className={cx(s.root)}>
    <span className={cx(s.text)}>404</span>
    <QuipuswapLogo404 className={s.svg} />
  </div>
);

export default NotFound;
